import { useMemo } from "react";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { getDateUpdate } from "../../Utils/utils";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const HelpPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: archivedNewsHtml = {}, isLoading: archivedNewsHtmlIsLoading } =
    useGetHtmlApiQuery({ url: 690, lang: languageType });
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  const pageBody = archivedNewsHtml?.body?.[0]?.value ?? "No content available";
  const pageTitle =
    archivedNewsHtml?.title?.[0]?.value ?? "No content available";

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(archivedNewsHtml?.changed?.[0]?.value);
  }, [archivedNewsHtml]);

  if (archivedNewsHtmlIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink={"/help"}
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

            <div className="row">
              <div className="container">
                {/* <div className="title-sec">
                  <h4>Help</h4>
                </div> */}
                <div dangerouslySetInnerHTML={{ __html: pageBody }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpPage;
